import styled from 'styled-components';

export const ContainerButtonPlay = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 3;
    width: 100%;
  }
`;
export const ButtonText = styled.span`
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  color: ${(props) => props.theme.colors.grey.dark};
  font-family: ${(props) => props.theme.font.family.heading};
  width: 0px;
  transition: width 120ms ease-in-out;
  overflow: hidden;

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    width: auto;
    font-size: 16px;
    line-height: 24px;
  }
`;

export const Button = styled.button`
  width: 72px;
  height: 72px;
  min-width: 72px;
  border-radius: 1000px;
  background-color: ${(props) => props.theme.colors.white};
  cursor: pointer;
  position: relative;
  z-index: 2;
  transition: all 120ms ease-in-out;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  img {
    transition: all 120ms ease-in-out;

    @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
      margin-right: 8px;
      width: 16px;
      height: 16px;
    }
  }

  &::before {
    content: '';
    width: 104px;
    height: 104px;
    position: absolute;
    top: calc(50% - 52px);
    left: calc(50% - 52px);
    z-index: 1;
    border-radius: 1000px;
    background: rgba(255, 255, 255, 0.1);
    transition: all 120ms ease-in-out;

    @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
      display: none;
    }
  }

  @media (min-width: ${(props) => props.theme.breakpoints.max_md}px) {
    &:hover {
      width: auto;
      min-width: 127px;
      height: 56px;
      padding: 0 32px;
      justify-content: start;

      img {
        width: 20px;
        height: 20px;
        margin-right: 16px;
      }

      ${ButtonText} {
        width: auto;
      }

      &::before {
        opacity: 0;
      }
    }
  }

  @media (max-width: ${(props) => props.theme.breakpoints.max_md}px) {
    width: auto;
    height: 48px;
    padding: 0 32px;
  }
`;
